// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"ReferralDetailPage_ContentWrapper__1UTE7"};